import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/files/icon-add-extra-file.svg'
import _imports_1 from '@/assets/files/icon-preview-file.svg'
import _imports_2 from '@/assets/files/icon-remove-extra-file.svg'
import _imports_3 from '@/assets/files/icon-download-file.svg'


const _hoisted_1 = { class: "extra-menu-add-files" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { for: "file" }
const _hoisted_4 = {
  key: 0,
  class: "icon",
  src: _imports_0,
  alt: "",
  "data-test": "file-list-header-button"
}

import { toRefs } from 'vue'

interface PROPS {
  buttonsVisible: boolean
  isFileSelected: boolean
  canDownloadAndPreviewFile: boolean
  canUpload: boolean
}
interface EMITS {
  (e: 'removeFile'): void
  (e: 'addFile', file: File): void
  (e: 'previewFile'): void
  (e: 'downloadFile'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FileListHeader',
  props: {
    buttonsVisible: { type: Boolean },
    isFileSelected: { type: Boolean },
    canDownloadAndPreviewFile: { type: Boolean },
    canUpload: { type: Boolean }
  },
  emits: ["removeFile", "addFile", "previewFile", "downloadFile"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { buttonsVisible, isFileSelected, canDownloadAndPreviewFile, canUpload } = toRefs(props)

function onChange(event: Event) {
  const files = (event.target as HTMLInputElement).files
  if (!files) return
  emits('addFile', files[0])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.$t('general__data__files-associated')) + ": ", 1),
    (_unref(buttonsVisible))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("input", {
            id: "file",
            type: "file",
            name: "file",
            style: {"display":"none"},
            accept: "image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,audio/*,video/,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
            onChange: onChange
          }, null, 32),
          _createElementVNode("label", _hoisted_3, [
            (_unref(canUpload))
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          (_unref(canDownloadAndPreviewFile))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: _normalizeClass(["icon", { disabled: !_unref(isFileSelected) }]),
                src: _imports_1,
                alt: "",
                "data-test": "file-list-header-button",
                onClick: _cache[0] || (_cache[0] = 
          () => {
            if (_unref(isFileSelected)) emits('previewFile')
          }
        )
              }, null, 2))
            : _createCommentVNode("", true),
          (_unref(canUpload))
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: _normalizeClass(["icon", { disabled: !_unref(isFileSelected) }]),
                src: _imports_2,
                alt: "",
                "data-test": "file-list-header-button",
                onClick: _cache[1] || (_cache[1] = 
          () => {
            if (_unref(isFileSelected)) emits('removeFile')
          }
        )
              }, null, 2))
            : _createCommentVNode("", true),
          (_unref(canDownloadAndPreviewFile))
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: _normalizeClass(["icon", { disabled: !_unref(isFileSelected) }]),
                src: _imports_3,
                alt: "download file",
                "data-test": "file-list-header-button",
                onClick: _cache[2] || (_cache[2] = 
          () => {
            if (_unref(isFileSelected)) emits('downloadFile')
          }
        )
              }, null, 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})